import { render, staticRenderFns } from "./TenFilter.vue?vue&type=template&id=4ae0a382&scoped=true"
import script from "./TenFilter.vue?vue&type=script&lang=js"
export * from "./TenFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae0a382",
  null
  
)

export default component.exports